import { QueryKey, useQuery } from "react-query";
import { getInspectionItemComments } from "../../api/inspections/getInspectionItemComments";
import useNetworkHeaders from "../../../../hooks/useNetworkHeaders";

interface IInspectionItemComments {
  inspectionId: string | number;
  sectionId: string | number;
  itemId: string | number;
}
export default function useInspectionItemComments({ inspectionId, sectionId, itemId }: IInspectionItemComments) {
  const headers = useNetworkHeaders();
  const queryKey = getInspectionItemCommentQueryKey(inspectionId, sectionId, itemId);

  const query = useQuery(
    queryKey,
    async () =>
      await getInspectionItemComments(headers)({
        id: Number(inspectionId),
        sectionId: Number(sectionId),
        itemId: Number(itemId),
      }),
  );

  return {
    data: query.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
  };
}

export function getInspectionItemCommentQueryKey(
  inspectionId: string | number,
  sectionId: string | number,
  itemId: string | number,
): QueryKey {
  return [["conversation", inspectionId.toString(), sectionId.toString(), itemId.toString()]].filter((key) => key);
}
